import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "tailwindcss/tailwind.css";
import AgencyList from "../agencies/agencyList";
import CreateStore from "../stores/CreateStore";
import StoreComponent from "../stores/StoreList";
import UserList from "../users/UserList";
import UserProfile from "../userprofile/UserProfile";
import Loader from "../loader/Loader";
import xenilogo from "../../assest/img/XENI-LOGO-01.png";
import UserActivity from "../useractivity/useractivity";

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("list");
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLoader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        if (!decodedToken.isMfaPass) {
          navigate("/verify-otp", {
            state: { username: decodedToken.UserName },
          });
        }
        setIsAdmin(decodedToken.isAdmin);
      } catch (error) {
        console.error("Failed to decode JWT token", error);
      }
    }
  }, [navigate]);

  const handleLogout = () => {
    setLoading(true);
    setTimeout(() => {
      localStorage.removeItem("token");
      navigate("/");
    }, 2000);
  };

  const updateUserApiCall = async (updatedUser) => {
    return new Promise((resolve) => setTimeout(resolve, 1000));
  };
  const handleUpdateUser = async (updatedUser) => {
    setLoading(true);
    try {
      await updateUserApiCall(updatedUser);
      setActiveTab("user management");
    } catch (error) {
      console.error("Failed to update user", error);
    } finally {
      setLoading(false);
    }
  };

  const updateAgencyApiCall = async (updatedAgency) => {
    return new Promise((resolve) => setTimeout(resolve, 1000));
  };
  const handleUpdateAgency = async (updatedAgency) => {
    setLoading(true);
    try {
      await updateAgencyApiCall(updatedAgency);
      setActiveTab("list");
    } catch (error) {
      console.error("Failed to update agency", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {loading && <Loader />}
      {/* Left side navigation */}
      <div className="sm:w-1/4 md:w-1/6 bg-gray-800 text-white p-4">
        <img src={xenilogo} alt="Logo" className=" sm:w-2/1 lg:w-1/2 mx-auto" />
        <ul className="space-y-4 mt-4">
          <li>
            <button
              onClick={() => setActiveTab("list")}
              className={`w-full text-left p-2 rounded hover:bg-white hover:text-black ${
                activeTab === "list" ? "bg-orange-500" : ""
              }`}
            >
              Agencies
            </button>
          </li>
          {isAdmin && (
          <li>
            <button
              onClick={() => setActiveTab("store")}
              className={`w-full text-left p-2 rounded hover:bg-white hover:text-black ${
                activeTab === "store" ? "bg-orange-500" : ""
              }`}
            >
              Stores
            </button>
          </li>
          )}
          {isAdmin && (
            <li>
              <button
                onClick={() => setActiveTab("user management")}
                className={`w-full text-left p-2 rounded hover:bg-white hover:text-black ${
                  activeTab === "user management" ? "bg-orange-500" : ""
                }`}
              >
                User Management
              </button>
            </li>
          )}
          <li>
            <button
              onClick={() => setActiveTab("user profile")}
              className="w-full text-left p-2 rounded hover:bg-white hover:text-black"
            >
              User Profile
            </button>
          </li>
          {isAdmin && (
          <li>
            <button
              onClick={() => setActiveTab("user activity")}
              className="w-full text-left p-2 rounded hover:bg-white hover:text-black"
            >
              User Activity
            </button>
          </li>
          )}
          <li>
            <button
              onClick={handleLogout}
              className="w-full text-left p-2 rounded text-white-500 hover:bg-red-500 hover:text-white"
            >
              Logout
            </button>
          </li>
        </ul>
      </div>

      {/* Right side content */}
      <div className="w-full p-8">
        {showLoader ? <Loader /> : null}
        {activeTab === "list" && (
          <AgencyList onUpdateAgency={handleUpdateAgency} />
        )}
        {!showLoader && activeTab === "store" && <StoreComponent />}
        {activeTab === "createStore" && (
          <CreateStore setActiveTab={setActiveTab} />
        )}
        {activeTab === "user management" && (
          <UserList onUpdateUser={handleUpdateUser} />
        )}
        {activeTab === "user profile" && <UserProfile />}
        {activeTab === "user activity" && <UserActivity />}
      </div>
    </div>
  );
}

export default AdminDashboard;
